import type { DashboardWidgetConfiguration } from './widget-definition';
import { period } from './query-period';

export const procurementVendorReportWidget: DashboardWidgetConfiguration = {
  widgetId: "procurement.vendor-report",
  name: "Spend by vendor",
  description: "Spend by vendor using the reusable report-widget visualization.",
  apps: [
    "home",
    "procurement",
  ],
  template: "report",
  query: {
    kind: "single",
    query: {
      version: 1,
      source: "procurement.purchases",
      ...period(30),
      select: [
        {
          type: "field",
          field: "vendor_name",
          as: "vendor_name",
        },
        {
          type: "aggregate",
          function: "sum",
          field: "total",
          as: "spend",
        },
      ],
      group_by: [
        {
          field: "vendor_name",
        },
      ],
      order_by: [
        {
          ref: "spend",
          direction: "desc",
        },
      ],
      limit: 8,
    },
  },
  inputs: {
    title: "Spend by vendor",
    subtitle: "Live RQL report",
    output: "category_series",
    visualization: "bar",
    icon: "average",
    showTimeControls: true,
  },
  dummyData: {
    value: "$92,750",
    series: [
      18,
      30,
      24,
      42,
      35,
    ],
  },
  limits: {
    minWidth: 6,
    maxWidth: 12,
    minHeight: 3,
    maxHeight: 8,
    defaultWidth: 6,
    defaultHeight: 4,
  },
};
